<label class="flex w-full flex-col gap-1 text-sm text-default">
  @if (labelText) {
    <span class="text-sm font-medium text-default">{{ labelText }}</span>
  }

  <textarea
    z-input
    [id]="inputId()"
    [attr.placeholder]="placeholder() || null"
    [attr.maxlength]="maxLength() || null"
    [readOnly]="readonly()"
    [disabled]="disabled()"
    [rows]="resolvedRows"
    [value]="displayValue"
    (input)="handleInput($event)"
    (blur)="handleBlur()"
    class="min-h-24 border border-border bg-card text-default placeholder:text-hint focus-visible:border-primary focus-visible:ring-primary/20 disabled:bg-disabled disabled:text-disabled"
  ></textarea>

  @if (charCount() && maxLength()) {
    <span class="text-xs text-secondary">{{ displayValue.length }}/{{ maxLength() }}</span>
  }
</label>
